import { inject, Injectable } from '@angular/core';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import { EMPTY } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

import { KycIdentificationApiService } from '@services/api/kyc-identification-api.service';

import * as KycIdentificationActions from './kyc-identification-actions';

@Injectable()
export class KycIdentificationEffects {
  private readonly actions$ = inject(Actions);
  private readonly kycIdentificationApiService = inject(KycIdentificationApiService);

  readonly loadKycIdentification$ = createEffect(() =>
    this.actions$.pipe(
      ofType(KycIdentificationActions.load),
      switchMap(() =>
        this.kycIdentificationApiService.getKycIdentification().pipe(
          map(kycIdentification => KycIdentificationActions.loadSuccess({ kycIdentification })),
          catchError(() => EMPTY)
        )
      )
    )
  );
}
